export default "__VITE_ASSET__aee69458__"